
<template>
    <div class="modal-overlay">
        <div class="modal-content">
            <div class="media-container">
                <iframe v-if="isVideo" :src="mediaUrl" frameborder="0" height="100%" width="100%"></iframe>
                <img
                  v-else
                  :src="mediaUrl"
                  class="media-content"
                >
            </div>
          <div class="container-button" @click="onFinish" :disabled="button_return">
            <div class="send-button" >
            <i class="fas fa-arrow-left"></i>
              <label class="send-text">Volver a la tienda</label>
            </div>
          </div>
        </div>
  
    </div>
  </template>
  
  
  <script>
    //import axios from "axios";
    
    export default {
      props: ["mediaUrl", "onFinish"],
      data() {
        return {
          button_return:false,
          isVideo:true,
          url: 'https://beta.vinapp.co/tutoriales/Reporte-de-Ventas-por-d%C3%ADa.mp4'
        };
      },
      computed: {
      },
      methods: {
        
      },
      mounted() {
        if(this.mediaUrl.includes('.jpg') || this.mediaUrl.includes('.png') || this.mediaUrl.includes('.jpeg')){
            this.isVideo = false;
        }
        console.log( 'mostrando url ' + this.mediaUrl)
      },
    };
    </script>
    
      
  <style scoped>
  
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    }
    .media-container {
    width: 95%;
    margin: 2% 2.5%;
    /*border: 1px solid black;*/
    height: 80%;
    }

    .media-content {
    max-width: 100%;
    height: 100%;
    margin: 0 auto;
    }

    .container-button{
    width: 100%;
    padding: 1.5% 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    }

    .send-button{
    width: 100%;
    background: #64B161;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    transition: all 1s;
    }

    .send-button label{
    color: #fff;
    margin-bottom: 0 !important;
    font-weight: 600;
    margin-top: 3px;
    }

    .send-button i:nth-child(1){
    color: #fff;
    margin-right: 0px;
    }

    .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 80%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: .3rem;
    outline: 0;
    height: 80%;
    }   

  </style>